// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"242":"b7b9219e","565":"b0aee213","971":"5b99be91"}[chunkId] + ".chunk.js";
};